import { MaterialSymbol } from '@florencelabs/icons';
import { ModalCloseButton, ModalWithTrigger } from '@florencelabs/modal-2';
import clsx from 'clsx';
import { ReactElement, ReactNode } from 'react';
import { Button } from 'react-aria-components';
import { useTranslation } from 'react-i18next';

export const CustomCalendarError = ({
  isOpen: isOpenTooltip,
  toggleModal,
  label,
  cta,
  children,
}: {
  label: string;
  cta: string;
  isOpen: boolean;
  toggleModal?: () => void;
  children?: ReactNode;
}): ReactElement => {
  const { t } = useTranslation();

  return (
    <ModalWithTrigger
      isOpen={isOpenTooltip}
      onOpenChange={toggleModal}
      trigger={
        children ? (
          <>{children}</>
        ) : (
          <Button
            slot={null}
            aria-hidden={true}
            onPress={toggleModal}
            className={clsx('flex h-6 w-6 flex-1 items-center justify-center')}
          >
            <MaterialSymbol
              name={'chevron_right'}
              aria-hidden={true}
              size={24}
              className={'text-gray-950/30'}
            />
          </Button>
        )
      }
      variant={'bottomDrawer'}
      modalClassName={'rounded-t-lg h-fit w-full'}
      dialogClassName={'px-0 pt-8 pb-12 gap-y-6'}
      overlayClassName={'bg-black/20'}
    >
      <div
        className={
          'flex min-h-[54px] flex-col items-center justify-between border-b border-black border-opacity-10'
        }
      >
        <div className={'flex w-full items-center px-6 tablet:px-16'}>
          <div className={'flex items-center gap-x-4'}>
            <MaterialSymbol name={'info'} size={24} />
            {label}
          </div>
          <ModalCloseButton
            slot={null}
            className={'relative ml-auto inline-block h-6 w-6 !py-0'}
            onPress={toggleModal}
            ariaLabel={t('close')}
          />
        </div>
      </div>
      <p
        className={
          'px-6 text-body-small text-gray-800 tablet:px-16 tablet:text-body-medium'
        }
      >
        {cta}
      </p>
    </ModalWithTrigger>
  );
};
